import { render, staticRenderFns } from "./no-permission.vue?vue&type=template&id=2ff378f5"
import script from "./no-permission.vue?vue&type=script&lang=js"
export * from "./no-permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports